import { render, staticRenderFns } from "./ProductScanSort.vue?vue&type=template&id=32e28a80&"
import script from "./ProductScanSort.vue?vue&type=script&lang=js&"
export * from "./ProductScanSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports